export const routingConstants = {
    paths: {
        homePage: '/',
        serviceConfiguration: '/service',
        userConfiguration: '/user',
        authenticationConfiguration: '/authentication',
        contentConfiguration: '/content',
        rolePermissionGroupConfiguration:
            '/rolepermissiongroup/:rolePermissionGroupId',
    },
}
